import { MediaType } from 'src/app/utils/media-type';

export interface DigitalEventDTO {
  ContactId: string;
  AttachData?: any;
  SessionDirection: DigitalSessionDirection;
  SessionEventType: DigitalSessionEventType;
  SessionEndReason?: DigitalSessionEndReason;

  mediaType: MediaType;
}

export enum DigitalSessionDirection {
  Inbound,
  Outbound,
}

export enum DigitalSessionEventType {
  Assigned,
  Unassigned,
}

export enum DigitalSessionEndReason {
  Closed,
  Transfered,
}
